const state = {
  loggedInUser: null,
  token: null,
  refreshToken: null,
  roles: null,
  attachmentPrivileges: null,
  queryDefs: null,
  extents: null,
  forbiddenWidgets: null,
  guestUser: null,
  arcGISPortalToken: null,
  acceptedTerms: false,
}

const getters = {
  getLoggedInUser: state => state.loggedInUser,
  getAccessToken: state => state.token,
  getRefreshToken: state => state.refreshToken,
  getAcceptedTerms: state => state.acceptedTerms,
  getRoles: state => state.roles,
  getAttachmentPrivileges: state => state.attachmentPrivileges,
  getQueryDefs: state => state.queryDefs,
  getForbiddenWidgets: state => state.forbiddenWidgets,
  getExtents: state => state.extents,
  getGuestUser: state => state.guestUser,
  getArcGISPortalToken: state => state.arcGISPortalToken,
}

const mutations = {
  setUser (state, userObject) {
    for (const key in userObject) {
      state[key] = userObject[key]
    }
  },
  setArcGISPortalToken (state, token) {
    state.arcGISPortalToken = token
  },
  removeUser (state) {
    for (const key in state) {
      state[key] = null
    }
  },
  setLoggedInUser (state, user) {
    state.loggedInUser = user
  },
  setAccessToken (state, token) {
    state.token = token
  },
  setRefreshToken (state, refreshToken) {
    state.refreshToken = refreshToken
  },
  setAcceptedTerms (state, acceptedTerms) {
    state.acceptedTerms = acceptedTerms
  },
}

const actions = {
  doLogin ({ commit }, userObject) {
    commit('setUser', userObject)
  },
  doLogout ({ commit }) {
    commit('removeUser')
  },
  doMixedAuth ({ commit }, userObject) {
    commit('setUser', userObject)
  },
  setLoggedInUser ({ commit }, user) {
    commit('setLoggedInUser', user)
  },
  setAccessToken ({ commit }, token) {
    commit('setAccessToken', token)
  },
  setRefreshToken ({ commit }, refreshToken) {
    commit('setRefreshToken', refreshToken)
  },
  setAcceptedTerms ({ commit }, acceptedTerms) {
    commit('setAcceptedTerms', acceptedTerms)
  },
  setArcGISPortalToken ({ commit }, token) {
    commit('setArcGISPortalToken', token)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
